
const golfinhos = [
  {
    id: 1,
    title: 'Observação de Golfinhos & Baleias',
    duration: '3h',
    price: '€55/pessoa',
    description: 'Saída de barco desde o Funchal para observar golfinhos e baleias no seu habitat natural. A Madeira é um dos melhores locais do mundo para avistamento de cetáceos.',
    highlights: ['Golfinhos comuns e roazes', 'Cachalotes e baleias-piloto', 'Guia biólogo marinho', 'Equipamento de snorkel incluído'],
    image: 'https://public.readdy.ai/ai/img_res/2cbfb9c8ed1051fd19e5baf5d0756954.jpg',
    badge: 'Mais Reservado',
    badgeColor: 'bg-sea-blue',
  },
  {
    id: 2,
    title: 'Mergulho com Tartarugas',
    duration: '4h',
    price: '€75/pessoa',
    description: 'Mergulho guiado nas águas cristalinas da Madeira para encontrar tartarugas marinhas, raias e uma incrível diversidade de vida marinha.',
    highlights: ['Tartarugas marinhas', 'Raias e polvos', 'Instrutor certificado PADI', 'Equipamento completo incluído'],
    image: 'https://readdy.ai/api/search-image?query=Scuba%20diving%20Madeira%20island%20clear%20blue%20Atlantic%20water%2C%20sea%20turtle%20swimming%20near%20coral%20reef%2C%20colorful%20marine%20life%2C%20underwater%20photography%2C%20tropical%20fish%2C%20crystal%20clear%20visibility%2C%20ocean%20adventure%2C%20beautiful%20underwater%20world&width=800&height=500&seq=golfinho2&orientation=landscape',
    badge: 'Aventura',
    badgeColor: 'bg-nature-green',
  },
  {
    id: 3,
    title: 'Passeio de Catamarã ao Pôr do Sol',
    duration: '2h30',
    price: '€45/pessoa',
    description: 'Navegue ao longo da costa sul da Madeira num luxuoso catamarã enquanto o sol se põe no horizonte. Inclui bebidas e petiscos a bordo.',
    highlights: ['Vista da costa ao pôr do sol', 'Bebidas e petiscos incluídos', 'Música ao vivo', 'Possibilidade de nadar'],
    image: 'https://readdy.ai/api/search-image?query=Catamaran%20sunset%20cruise%20Madeira%20island%20coast%2C%20luxury%20sailing%20boat%20on%20calm%20Atlantic%20ocean%2C%20golden%20sunset%20sky%2C%20dramatic%20coastal%20cliffs%2C%20romantic%20evening%2C%20people%20relaxing%20on%20deck%2C%20drinks%2C%20beautiful%20orange%20and%20pink%20sky&width=800&height=500&seq=golfinho3&orientation=landscape',
    badge: 'Romântico',
    badgeColor: 'bg-rose-500',
  },
];

const GolfinhoSection = () => {
  return (
    <section id="golfinhos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sea-blue text-xs font-semibold uppercase tracking-widest mb-3">Oceano Atlântico</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Mar & <span className="font-serif italic text-sea-blue">Golfinhos</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            A Madeira é um santuário de cetáceos. Mais de 28 espécies de golfinhos e baleias habitam as águas ao redor da ilha.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {golfinhos.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span className={`absolute top-4 left-4 ${item.badgeColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}>
                  {item.badge}
                </span>
                <div className="absolute bottom-4 left-4 right-4 flex justify-between items-center">
                  <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-time-line"></i> {item.duration}
                  </span>
                  <span className="bg-white/90 text-gray-900 text-sm font-bold px-3 py-1 rounded-full">
                    {item.price}
                  </span>
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-5 flex-1">{item.description}</p>
                <ul className="space-y-2 mb-6">
                  {item.highlights.map((h, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                      <div className="w-4 h-4 flex items-center justify-center shrink-0">
                        <i className="ri-check-line text-sea-blue font-bold"></i>
                      </div>
                      {h}
                    </li>
                  ))}
                </ul>
                <a
                  href="https://wa.me/351912345678"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full py-3 bg-sea-blue/10 text-sea-blue rounded-full font-semibold text-sm hover:bg-sea-blue hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  Saber Mais
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GolfinhoSection;
